import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { voyageBullets } from '../voyageBullets-sidecar'
import { EVoyageMessage } from './voyageMessageIds'

export interface IVoyageMessageBulletCreate {
  bulletId: number
  firedCrewId: number
  type: EMessageBulletType
  team: number
  x: number
  y: number
  dx: number
  dy: number
  rot: number
}

export enum EMessageBulletType {
  Crew = 0,
  Alien = 1,
}

export const voyageMessageId = EVoyageMessage.BulletCreate

export function write(m: IMessageWriter, d: IVoyageMessageBulletCreate) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write32(m, d.bulletId)
  messageWriter.write32(m, d.firedCrewId)
  messageWriter.write8(m, d.type)
  messageWriter.write8(m, d.team)
  messageWriter.writeFloat(m, d.x)
  messageWriter.writeFloat(m, d.y)
  messageWriter.writeFloat(m, d.dx)
  messageWriter.writeFloat(m, d.dy)
  messageWriter.writeFloat(m, d.rot)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)

  let d: IVoyageMessageBulletCreate = {
    bulletId: messageWriter.read32(m),
    firedCrewId: messageWriter.read32(m),
    type: messageWriter.read8(m),
    team: messageWriter.read8(m),
    x: messageWriter.readFloat(m),
    y: messageWriter.readFloat(m),
    dx: messageWriter.readFloat(m),
    dy: messageWriter.readFloat(m),
    rot: messageWriter.readFloat(m),
  }

  return d
}

export function test() {
  let ex: IVoyageMessageBulletCreate = {
    bulletId: 100,
    firedCrewId: 123,
    type: 5,
    team: 1,
    x: 7,
    y: 8,
    dx: 123.123,
    dy: 32.234,
    rot: 34.1234,
  }
  messageWriter.test('bullet-create', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)
  voyageBullets.create(msg)
}

export function sendMessageAndImmediatelyExecute(
  msg: IVoyageMessageBulletCreate,
) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
